const OFF = new Set(['off', '0', 'false']);
const ON = new Set(['on', '1', 'true']);
export function resolveUplinkCcOptions(input) {
    const params = new URLSearchParams(input.search);
    const param = params.get('uplinkCc');
    const tune = params.get('uplinkCcTune') ?? undefined;
    if (param !== null && OFF.has(param)) {
        return { enabled: false, tune };
    }
    if (param !== null && ON.has(param)) {
        return { enabled: true, tune };
    }
    const stored = input.localStorageValue;
    if (stored !== null && OFF.has(stored)) {
        return { enabled: false, tune };
    }
    return { enabled: true, tune };
}
/** Browser entry point: page URL + localStorage. */
export function readUplinkCcOptions() {
    let search = '';
    let localStorageValue = null;
    try {
        search = window.location.search;
        localStorageValue = window.localStorage.getItem('uplinkCc');
    }
    catch {
        // no window / storage access: defaults
    }
    return resolveUplinkCcOptions({ search, localStorageValue });
}
